import React from 'react';
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as rootActions } from '../actions'
import { NAME as PRODUCT_TYPE_NAME } from '../reducer'
import {Button, TextField} from '@material-ui/core'
import Table from "../../../components/DefaultTable"
import ResponsiveDrawer from "../../../components/ResponsiveDrawer"
import LoadError from "../../../components/LoadError"


function mapStateToProps(state) {
    return {
        ...state[PRODUCT_TYPE_NAME]
    }
}


const mapDispatchToProps = (dispatch) => bindActionCreators({
    ...rootActions,
}, dispatch)


class ProductTypeList extends React.Component {
    constructor(props) {
        super(props);
        props.getProductTypeList()
    }
    render() {
      if (this.props.loadError) {
        return <LoadError onRetry={this.props.getProductTypeList} />
      }
      return(
        <div>
          <Table tableDescription = {{
            columns: this.props.tableColumns,
            data: this.props.productTypeList
          }}/>         
        </div>
      )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductTypeList)
